/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Add edge</h4>

<p>Add an edge between two vertices or draw an edge on a face.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('556486542')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>E</b>: Add edge</li>
    <li class='shortcuts__item'><b>Shift-E</b>: Add straight edge</li>
</ul>`;

export default function AddEdgeTooltip() {
    return h('div', { innerHTML: body });
}
